const UserSolid = ({ width }) => {
    return (
        <div className={`user-icon ${width} text-[#231F20]`}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95.54 95.54">
                <g>
                    <circle
                        cx="47.8"
                        cy="47.64"
                        r="43.24"
                        fill="transparent"
                    ></circle>
                    <path
                        fill="#231F20"
                        d="M76.08 84.68h-6.25c0-12.16-9.9-22.06-22.06-22.06s-22.06 9.89-22.06 22.06h-6.25c0-15.61 12.7-28.31 28.31-28.31s28.31 12.7 28.31 28.31zM47.77 44.96c-6.93 0-12.57-5.64-12.57-12.57s5.64-12.57 12.57-12.57 12.57 5.64 12.57 12.57-5.64 12.57-12.57 12.57zm0-18.9c-3.49 0-6.32 2.84-6.32 6.32s2.84 6.32 6.32 6.32 6.32-2.84 6.32-6.32-2.84-6.32-6.32-6.32z"
                    ></path>
                    <path
                        fill="currentColor"
                        d="M47.77 95.54C21.43 95.54 0 74.11 0 47.77S21.43 0 47.77 0s47.77 21.43 47.77 47.77-21.43 47.77-47.77 47.77zm0-89.29c-22.89 0-41.52 18.62-41.52 41.52s18.63 41.52 41.52 41.52 41.52-18.62 41.52-41.52S70.66 6.25 47.77 6.25z"
                    ></path>
                </g>
            </svg>
        </div>
    )
}

export default UserSolid
